import React from 'react';
import { faq } from "../content/text";
import { motion } from "framer-motion";
import centerImg from "../../images/center.png";

export const FAQ_Accordion = ({ limit, activeIndex, setActiveIndex }) => {
    // We have 5 items. We want to distribute them along the right half of the circle.
    // Angles in degrees. 0 degrees is 3 o'clock (center right).
    // Let's spread them from -60 degrees (top right) to +60 degrees (bottom right).
    const angles = [-60, -30, 0, 30, 60];

    // The dial rotates so the active index is always at 0 degrees.
    // E.g., if activeIndex = 0, angle is -60. We must rotate dial by +60 so it becomes 0.
    const dialRotation = -angles[activeIndex];

    return (
        <div className="faq_v24_dial_viewport">
            
            {/* Center Core of the Ring (Static, does not spin with dial) */}
            <div className="faq_v24_ring_core">
                {/* High-Tech Animated Orbital Rings */}
                <div className="faq_v24_orbital ring_1"></div>
                <div className="faq_v24_orbital ring_2"></div>
                <div className="faq_v24_orbital ring_3"></div>
                
                {/* Intense Glowing Backdrop for dark logo visibility */}
                <div className="faq_v24_core_glow"></div>

                <img src={centerImg} alt="ActoLoan Center" className="faq_v24_core_logo" />
            </div>

            {/* The Massive Spinning Ring */}
            <motion.div 
                className="faq_v24_massive_ring"
                animate={{ rotate: dialRotation }}
                transition={{ type: "spring", stiffness: 60, damping: 20 }}
            >
                {faq.map((item, index) => {
                    if (index >= limit) return null;
                    
                    const isHoveredOrActive = activeIndex === index;
                    
                    // Position each node exactly on the edge of the massive circle
                    return (
                        <div 
                            key={index} 
                            className="faq_v24_node_anchor"
                            style={{ transform: `rotate(${angles[index]}deg)` }}
                        >
                            {/* The Node itself */}
                            {/* We must COUNTER-ROTATE the node by both its own angle AND the dial's rotation so text remains perfectly upright! */}
                            <motion.div 
                                className={`faq_v24_node ${activeIndex === index ? 'active' : ''}`}
                                onClick={() => setActiveIndex(index)}
                                animate={{ rotate: -angles[index] - dialRotation }}
                                transition={{ type: "spring", stiffness: 60, damping: 20 }}
                            >
                                <div className="node_dot"></div>
                                <div className="node_content">
                                    <span className="node_num">0{index + 1}</span>
                                    <h4>{item?.ques}</h4>
                                </div>
                            </motion.div>
                        </div>
                    );
                })}

            </motion.div>
        </div>
    );
};
